const local = {
  BASE_URL: 'http://dev.localhost:5000',
  APPS_SERVER: 'http://dev.localhost:5000/graphql',
  HI_BASE: 'http://hi.dev.localhost:3300',
  HI_SERVER: 'http://hi.dev.localhost:3300/graphql',
  PII_SERVER: 'http://pii.dev.localhost:3200/graphql',
  PII_PUBLIC_SERVER: 'http://pii.dev.localhost:3200/graphql/public',
  HPD_SERVER: 'http://dev.localhost:8029/local/hpd',
};

const dev = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  APPS_SERVER: process.env.REACT_APP_APPS_LEGACY_URL,
  HI_BASE: process.env.REACT_APP_HI_ROOT_URL,
  HI_SERVER: process.env.REACT_APP_HI_LEGACY_URL,
  PII_SERVER: process.env.REACT_APP_PII_LEGACY_URL,
  PII_PUBLIC_SERVER: process.env.REACT_APP_PUBLIC_PII_LEGACY_URL,
  HPD_SERVER: process.env.REACT_APP_HPD_SERVER_URL,
};

const staging = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  APPS_SERVER: process.env.REACT_APP_APPS_LEGACY_URL,
  HI_BASE: process.env.REACT_APP_HI_ROOT_URL,
  HI_SERVER: process.env.REACT_APP_HI_LEGACY_URL,
  PII_SERVER: process.env.REACT_APP_PII_LEGACY_URL,
  PII_PUBLIC_SERVER: process.env.REACT_APP_PUBLIC_PII_LEGACY_URL,
  HPD_SERVER: process.env.REACT_APP_HPD_SERVER_URL,
};

const prod = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  APPS_SERVER: process.env.REACT_APP_APPS_LEGACY_URL,
  HI_BASE: process.env.REACT_APP_HI_ROOT_URL,
  HI_SERVER: process.env.REACT_APP_HI_LEGACY_URL,
  PII_SERVER: process.env.REACT_APP_PII_LEGACY_URL,
  PII_PUBLIC_SERVER: process.env.REACT_APP_PUBLIC_PII_LEGACY_URL,
  HPD_SERVER: process.env.REACT_APP_HPD_SERVER_URL,
};

// default to local if app stage is not set
const stage = process.env.REACT_APP_STAGE || 'local';

const config = {
  BASE_NAME: '/np/dashboard',

  ...(stage === 'prod' ? prod : stage === 'staging' ? staging : stage === 'dev' ? dev : local),
};

export default config;
